import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Box } from '@ally/metronome-ui'
import { toJSON } from '@ally/fido'
import { useHostServices } from '../HostServices'
import TipsMbox from './Tips'

const Wrapper = styled(Box)`
  ${({ theme: { colors, space } }): string => `
    padding: ${space.sm};
    margin-bottom: ${space.md};
    box-shadow: 0 2px 4px -2px rgba(0, 0, 0, 0.16), 0 5px 8px -4px rgba(0, 0, 0, 0.16);
    border: 1px solid ${colors['gray-300']};
    border-radius: 4px;
  `};
`

export const apiKey = 'uUjB04cmbA3MZU6VymTc5cty7xKKzyZu'

export const PegaIbubble: React.FC = () => {
  const { session } = useHostServices()
  const guid = session.data?.guid

  const [tips, setTips] = useState([])

  useEffect(() => {
    async function getData(): Promise<void> {
      const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'api-key': apiKey,
      }
      const requestBody = {
        CustomerID: guid,
        Channel: 'Web',
        ContainerName: 'iBubble',
        Direction: 'Inbound',
        Placements: 'iBubble',
      }

      const containerUrl = '/acs/cihcontainer-forweb/Container'

      const response = await fetch(containerUrl, {
        method: 'POST',
        headers,
        body: JSON.stringify(requestBody),
      })

      const data = await toJSON<any>(response)
      setTips(
        data.ContainerList[0].RankedResults
          ? data.ContainerList[0].RankedResults
          : [],
      )
    }
    getData()
  }, [])
  return (
    <>
      {tips.length > 0 ? (
        <Wrapper>
          <TipsMbox tips={tips} />
        </Wrapper>
      ) : null}
    </>
  )
}
